import { actionTypes } from "./constants";

export const initialState = {
    data: null,   
    previousRequestSource: null,
    fetching: false
}

export const botActivityReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_BOT_ACTIVITY_DATA:
            return {
                ...state,
                data: action.payload
            }
        case actionTypes.SET_BOT_ACTIVITY_CANCEL_TOKEN:
            return {
                ...state,
                previousRequestSource: action.previousRequestSource
            }
        case actionTypes.IS_BOT_ACTIVITY_FETCHING:
            return {
                ...state,
                fetching: action.fetching
            }
        default:
            return state;
    }
} 